export interface ShipmentQuotation {
    friendly_id: string;
    id: string;
    quotation_offer_id: string;
    carrier_name?: string;
    rate_name?: string;
    currency: string;
    total_amount: number;
}
